interface Segment {
  id: string;
  label: string;
  count: number;
}

interface SegmentPillsProps {
  segments: Segment[];
  activeSegment: string | null;
  onSelect: (id: string | null) => void;
}

/**
 * Horizontal pill bar for segmented filtering.
 * Clicking the active segment deselects it (shows all).
 */
export function SegmentPills({ segments, activeSegment, onSelect }: SegmentPillsProps) {
  return (
    <div class="segment-pills">
      <button
        class={`segment-pill${activeSegment === null ? ' active' : ''}`}
        onClick={() => onSelect(null)}
        type="button"
      >
        All
      </button>
      {segments.map((seg) => (
        <button
          key={seg.id}
          class={`segment-pill${activeSegment === seg.id ? ' active' : ''}`}
          onClick={() => onSelect(activeSegment === seg.id ? null : seg.id)}
          type="button"
        >
          {seg.label} ({seg.count})
        </button>
      ))}
    </div>
  );
}
